import { ContractInfoProcessor } from './ContractInfoProcessor';
export const getContractInfo = (context, smartContract) => new ContractInfoProcessor(context, smartContract).process();

//# sourceMappingURL=getContractInfo.js.map
